import React, { PureComponent } from "react";
import { Tabs, Tab } from 'material-ui/Tabs';
import {inject, observer} from 'mobx-react';

import { PageWrapper } from "components/PageWrapper";
import { Dashboard, Sessions, Performance } from "../components";

import { TABS, TAB_ACTIVE_STYLES, TAB_STYLES } from "../constants";

import HttpClient from 'services/HttpClient';

const MCQ_THEMES_API = '/api/v1/themes';

@inject('mcqThemesStore')
@observer
export class McqMainSection extends PureComponent {
  constructor() {
    super();

    this.state = {
      activeTab: TABS.DASHBOARD,
    };
  }

  componentDidMount() {
    const { mcqThemesStore } = this.props;

    new HttpClient().get(MCQ_THEMES_API)
    .then(({ body }) => {
      mcqThemesStore.setMcqThemes(body.data.theme);
    })
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;

    return (
      <PageWrapper>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          inkBarStyle={{background: 'transparent'}}
          className='course-tabs-component'
        >
          <Tab
            label="Dashboard"
            value={TABS.DASHBOARD}
            buttonStyle={activeTab === TABS.DASHBOARD ? TAB_ACTIVE_STYLES : TAB_STYLES}
            className={activeTab === TABS.DASHBOARD ? 'btn-new-main' : 'btn-new-white'}
          >
            <Dashboard handleTabChange={this.handleTabChange} /> 
          </Tab>
          <Tab
            label="SESSIONS"
            value={TABS.SESSIONS}
            buttonStyle={activeTab === TABS.SESSIONS ? TAB_ACTIVE_STYLES : TAB_STYLES}
            className={activeTab === TABS.SESSIONS ? 'btn-new-main' : 'btn-new-white'}
          >
            <Sessions />
          </Tab>
          <Tab
            label="PERFORMANCE"
            value={TABS.PERFORMANCE}
            buttonStyle={activeTab === TABS.PERFORMANCE ? TAB_ACTIVE_STYLES : TAB_STYLES}
            className={activeTab === TABS.PERFORMANCE ? 'btn-new-main' : 'btn-new-white'}
          >
            <Performance />
          </Tab>
        </Tabs>
      </PageWrapper>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/mcq/containers/MainSection.js